// Module
var code = "<div class=\"dashboard\">\n    <div class=\"container-fluid\">\n        <div class=\"dashboard__header\">\n            <div class=\"dashboard__title\">\n                <h1>Service history</h1>\n            </div>\n        </div>\n    </div>\n\n    <div dashboard-requests=\"'history'\"></div>\n</div>";
// Exports
var _module_exports = code;;
var path = 'template/dashboard/bike-business-supervisor/organisation/organisation-requests-history.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;